import React from 'react';

const AboutUs = () => {
  return (
    <section className="about-us" id="about-us-section">
      <h2>About Us</h2>
      <hr className="section-divider" />
      <div className="about-header">
        <h3>Sachchiyay Exports — The True Taste of Purity</h3>
        <p>
          Established in 2025, Sachchiyay Exports is a trusted name in the export of premium organic spices from India.
          We are dedicated to delivering the authentic taste and aroma of nature through 100% pure, chemical-free, and
          sustainably sourced spices that reflect India’s rich agricultural heritage.
          <br /><br /><br />
          At Sachchiyay Exports, honesty and purity define everything we do. We work closely with certified organic
          farmers to ensure every spice is cultivated naturally, processed hygienically, and packed meticulously to
          preserve its original flavor, color, and nutritional values. Our operations are fully compliant with food
          safety standards and proudly FSSAI certified, affirming our commitment to quality and authenticity.
          <br /><br /><br />
          Backed by modern processing and packaging facilities, our team ensures that each product embodies our promise
          of purity, integrity, and excellence. Sachchiyay Exports continues to bring the true taste of purity from
          Indian farms to the world.
        </p>
        <p className="final-tagline">
          Sachchiyay Exports continues to spice up global cuisine with integrity, purity, and excellence — delivering
          **“The True Taste of Purity.”**
        </p>
      </div>
    </section>
  );
};

export default AboutUs;